import { render, staticRenderFns } from "./ComponentCreater.vue?vue&type=template&id=3949169d"
import script from "./ComponentCreater.vue?vue&type=script&lang=js"
export * from "./ComponentCreater.vue?vue&type=script&lang=js"
import style0 from "./ComponentCreater.vue?vue&type=style&index=0&id=3949169d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports